import { Card } from '@mui/material';
import { useBulkRejectRequestsBankOps } from 'pages/Finance/RequestsBankOps/hooks/useBulkRejectRequstsBankOps';
import { maxLength, required, useNotify } from 'react-admin';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs/Dialog/Dialog';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TextInput } from 'shared/react-admin/Inputs';

type Props = {
  ids: number[];
  onSuccess: () => void;
} & DialogProps;

type FormValues = {
  comment: string;
};
export const RequestsBankOpsListDatagridBulkRejectDialog: React.FC<Props> = ({
  ids,
  onSuccess,
  ...restProps
}) => {
  const notify = useNotify();

  const form = useForm<FormValues>();
  const { bulkRejectRequestsBankOps } = useBulkRejectRequestsBankOps();

  const onClose = () => {
    form.reset();
    restProps.onClose();
  };

  const onSubmit: SubmitHandler<FormValues> = (values) => {
    bulkRejectRequestsBankOps.mutate(
      {
        ids,
        comment: values?.comment,
      },
      {
        onSuccess: () => {
          onSuccess?.();

          notify(
            `Заявка на банковскую операцию ID ${ids.join(', ')} переведена в статус Отклонена`,
            {
              type: 'success',
            },
          );
        },
      },
    );
  };

  return (
    <Dialog {...restProps} width="640px">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Card>
            <CardHeader
              appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
              title="Отклонить запросы на согласование?"
              titleSize="smallBold"
            />
            <CardContent>
              <Typography>
                После отклонения заявки на банковские операции будут возвращены на доработку
                ответственному сотруднику из вашей рабочей группы.
                <br />
                <br />
                Перед отклонением обязательно оставьте комментарий.
              </Typography>
              <Box sx={{ marginTop: '24px' }}>
                <TextInput
                  fullWidth
                  helperText={false}
                  label="Комментарий"
                  multiline
                  resettable
                  size="small"
                  source="comment"
                  validate={[
                    required(),
                    maxLength(
                      1024,
                      'Это значение слишком длинное. Оно должно содержать 1024 символа или меньше.',
                    ),
                  ]}
                  variant="outlined"
                />
              </Box>
            </CardContent>
            <CardActionsButtons
              rightActionsSlot={[
                <CancelButton
                  key="back-button"
                  label="Отменить"
                  onClick={onClose}
                  variant="outlined"
                />,
                <Button
                  color="error"
                  key="ok-button"
                  label="Подтвердить"
                  type="submit"
                  variant="contained"
                />,
              ]}
            />
          </Card>
        </form>
      </FormProvider>
    </Dialog>
  );
};
